<script>
export default {
    name: 'ErrorModal',
    props: {
        data: {
            type: Object,
            default: () => ({}),
        },
    },
    methods: {
        close() {
            this.$emit('close')
        },
    },
}
</script>

<template>
    <div>
        <h2>Error</h2>
        <p>{{ data.message || 'Something went wrong' }}</p>
        <button @click="close">OK</button>
    </div>
</template>